import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import ButtonSort from '../../../containers/ProposalStatsPage/Table/ButtonSort';
import Row from '../../../containers/ProposalStatsPage/Table/Row';
import { StyledTable, TableCell } from './styles';
import { Api } from '../../../typings/api';
import { SortOn } from '../../../containers/ProposalStatsPage/reducer';

interface TableProps {
	proposalStatus: Api.ProposalStatus;
	allIds: string[];
}

const Table = ({ proposalStatus, allIds }: TableProps) => (
	<StyledTable>
		<thead>
			<tr>
				<TableCell as="th">
					<ButtonSort
						field={SortOn.TYPE}
						label="messages.type"
					/>
				</TableCell>
				<TableCell as="th">
					<ButtonSort
						field={SortOn.LABEL}
						label="messages.resource_name"
					/>
				</TableCell>
				{proposalStatus === Api.ProposalStatus.SEEN &&
					<>
						<TableCell as="th">
							<ButtonSort
								field={SortOn.READ}
								label="messages.status_read"
								isDefaultDesc={true}
							/>
						</TableCell>
						<TableCell as="th">
							<Translate value="messages.downloads" />
						</TableCell>
					</>
				}
				<TableCell as="th">
					<ButtonSort
						field={SortOn.SENT}
						label="messages.sent_date"
						isDefaultDesc={true}
					/>
				</TableCell>
				{proposalStatus === Api.ProposalStatus.SEEN &&
					<TableCell as="th">
						<ButtonSort
							field={SortOn.OPENED}
							label="messages.opened_date"
							isDefaultDesc={true}
						/>
					</TableCell>
				}
			</tr>
		</thead>
		<tbody>
			{allIds.length > 0
				? allIds.map(id => <Row key={id} id={id} />)
				: (
					<tr>
						<TableCell colSpan={5}>
							<Translate value="messages.no_data_found" />
						</TableCell>
					</tr>
				)
			}
		</tbody>
	</StyledTable>
);

export default Table;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/index.tsx